<template>
  <div class="container loop-counter" @click.stop="focus">
    <el-input-number
      v-model="fontSize"
      size="mini"
      @focus="togglePreventDefault(false)"
      @blur="togglePreventDefault(true)"
      @change="changeFontSize"
      :min="6"
      :max="500"
      ref="inputNumber"
    ></el-input-number>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'myInputRow',
  props: {
    sprite: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      fontSize: 30
    }
  },
  computed: {
    ...mapGetters([
      'TOOL',
      'SelectScenes_Msg',
      'SelectSprites_Msg',
      'SpriteBeforeSwap'
    ]),
  },
  methods: {
    render () {
      this.fontSize = this.sprite.font.fontSize;
    },
    togglePreventDefault (val) {
      // 是否启用快捷键
      this.$store.commit('toggle_isPreventDefault', val);
    },
    changeFontSize () {
      this.TOOL
        .updateSprite(this.sprite.id, {
          font: {
            fontSize: this.fontSize
          }
        }, this.sprite.scenesId, true);
    },
    focus (flag) {
      this.$refs.inputNumber.focus();
      let inputEl = this.$el.querySelector('input');
      if (!flag) {
        inputEl.blur();
      } else {
        inputEl.focus();
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/popupsNew/textSetting/inputRow.vue